/**
 * O painel da chamada (a transcrição) está aberto? Na sala ampliada começa aberto; nas janelas compactas (a janelinha
 * da guia e a janela flutuante) começa fechado e abre pelo botão da barra. A escolha da pessoa (`pref`: `true`,
 * `false` ou `null` = nunca escolheu) vale em qualquer janela daí em diante.
 * @param {boolean|null|undefined} pref @param {'room'|'compact'|'guest'} variant
 */
export const isPanelOpen = (pref, variant) => (pref ?? variant === 'room');
